// office_port/documents: документы старого Office (/document/..., /dict/report/...) генерирует бэкенд My Space —
// GET /office_port/documents<адрес Office> с токеном; имя файла — из Content-Disposition (как в Office),
// ошибка (400 с текстом, как отвечал Office) — тостом.
import instance from "@/services/api";
import { showErrorToast } from "@/services";

const fileName = (cd, fallback) => {
  const m = (cd || "").match(/filename\*=UTF-8''([^;]+)/i) || (cd || "").match(/filename="?([^";]+)"?/i);
  return m ? decodeURIComponent(m[1]) : fallback;
};

export const officeDocumentPath = (officeUrl) => `/office_port/documents${officeUrl.startsWith("/") ? "" : "/"}${officeUrl}`;

export const downloadOfficeDocument = async (officeUrl, fallbackName = "document.docx") => {
  try {
    const res = await instance(true, null, { throwError: true, showToast: false }).get(officeDocumentPath(officeUrl), {
      responseType: "blob",
    });
    if (!res?.data) return false;
    const url = URL.createObjectURL(res.data);
    const a = document.createElement("a");
    a.href = url;
    a.download = fileName(res.headers?.["content-disposition"], fallbackName);
    document.body.appendChild(a);
    a.click();
    a.remove();
    setTimeout(() => URL.revokeObjectURL(url), 1000);
    return true;
  } catch (e) {
    let text = "";
    try {
      text = await e?.response?.data?.text?.();
    } catch (_) {
      text = "";
    }
    showErrorToast(text || "Не удалось сформировать документ");
    return false;
  }
};
